<template>
	<div>
		<navigation-component></navigation-component>
		<div class="main-content" id="panel">
	  		<header-component></header-component>
	  		<!-- Header -->
	  		<div :class="classHeader">
	  			<!-- Mask -->
	  			<span class="mask bg-gradient-default opacity-1"></span>
	  			<!-- Header container -->
	  			<div class="container-fluid text-white  align-items-center">
	  				<div class="row">
	  					<div class="col-lg-9 col-md-10 mt-4">
	  						<h1 class="display-3 text-white">Biblioteca digital</h1>
	  						<p :class="classTextWelcome">
	  						Seleccione un libro</p>
	  					</div>
						<div class="col-lg-3 col-md-2 mt-4 float-right" v-if="hostname == 'bpo.etciberoamerica.com'">
	  						<img src="assets/img/bpo-academy-white-md.png" class="float-right">
	  					</div>
	  				</div>
	  			</div>
	  		</div>
	  		<!-- Page content -->

	  		<div class="container-fluid mt--6">
	  			<div class="row">
	  				<!--columna1-->
	  				<div class="col-sm-4" v-for="version in versiones" :key="version.id" :id="'version' + version.id">
	  					<!--card de modulo-->
	  					<div class="card bg-gradient-lighter">
	  						<!-- Card body -->
	  						<div class="card-body">
	  							<div class="row">
	  								<div class="col">
	  									<h5 class="card-title mb-0 ">{{version.nombre}}</h5>
	  								</div>
	  								<div class="col-auto">
	  									<img alt="Image placeholder" src="assets/img/icons/libro_digital.png" class="img-fluid">
	  								</div>
	  							</div>
                                <div class="row">
                                    <button type="button" :id="'btnIngresa' + version.id" class="btn btn-xs btn-primary" @click="ingresar(version.idversion)"><i class="ni ni-button-power"></i> Abrir</button>
                                </div>
	  						</div>
	  					</div>
					</div>
					<!--termina columna 1-->
				</div>
	  		</div>
	  	</div>
	</div>
</template>

<script>
	import Vue from 'vue'
	import VueForm from "vue-form"
	import NavigationComponent from '@/components/NavigationComponent'
	import HeaderComponent from '@/components/HeaderComponent'
	import options from "../validations/validations.js";
	Vue.use(VueForm, options);
	export default {
		name: 'Ebooks',
		components: {
			NavigationComponent, HeaderComponent
		},
		data() {
			return {
				productos: [],
				formstate: {},
				id_plataforma: 0,
				productosusuario: [],
				textoBotonCodigo: 'Activar curso',
				model: {
					codigo: '',
					password: '',
				},
				usuario: user,
				codigosUsuario: [],
				codigosSimulador: 0,
				puedeActivarGmetrix: 0,
				hostname: '',
				classHeader: 'header bg-gradient-default pb-6 d-flex align-items-center',
				classTextWelcome: 'mt-0 mb-5',
				versiones: []
			}
		},

		methods: {

			async ingresar(id_version) {
                window.open('http://ebook.etciberoamerica.com/es/Ebooks/ShowEbook?master=1&Access=1&EbookURL=' + id_version)
			},
			async registraAcceso(id_producto) {
				await axios.post(apiKS + 'api/accesos', { id_producto}, { headers })
				.then( response => {
					
				})
				.catch( error => {
					this.catchError()
				})
			},
		},
		
		async mounted() {
			this.hostname = hostname
			if(!user) {
                await this.getUserApi()
                this.usuario = user
            }

            this.openLoading()
			await this.getCodigosUsuario()

			this.codigosUsuario.forEach(codigo => {

				codigo.codigo.productos.forEach( producto => {
                    if(producto.id == 14) {
                        producto.versiones.forEach( version => {
                            this.versiones.push(version)
                        } )
                    }
				} )
			})
            Swal.close()
		},
		beforeMount() {
			document.body.classList.remove('bg-mos1')
			if(hostname == 'bpo.etciberoamerica.com') {
				this.classHeader = 'header bg-gradient-gray-dark pb-6 d-flex align-items-center'
				this.classTextWelcome = 'mt-0 mb-5 text-orange'
			}
		}
	}
</script>
